import { CheckCircleFilled, CloseCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const PendingRequestActions = (
  onApprove: () => void,
  onDeny: () => void
) => {
  const Approve = (
    <Button key="approve" type="primary" onClick={onApprove}>
      <CheckCircleFilled /> Approve
    </Button>
  );

  const Deny = (
    <Button key="deny" type="default" onClick={onDeny}>
      <CloseCircleOutlined /> Deny
    </Button>
  );

  return [Approve, Deny];
};
